import axios from 'axios'

export const BASE_API_URL = `${process.env.VUE_APP_API_URL}/api/`

export const api = axios.create({
  baseURL: BASE_API_URL
})
